import { render, staticRenderFns } from "./GroupInviteAction.vue?vue&type=template&id=571717e0&"
import script from "./GroupInviteAction.vue?vue&type=script&lang=js&"
export * from "./GroupInviteAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports